import { getBackgroundColor, getPaletteColor, themeGet, getTextColor } from '@magalu/stereo-ui-styles';
import styled from 'styled-components';
import Box from '../../atoms/Box';
import Flex from '../../atoms/Flex';
import Text from '../../atoms/Text';
import Button from '../../atoms/Button';
import { TabList } from '../../atoms';
export const Container = styled(Box)``;
export const CardTab = styled(Flex)`
  padding: 2px;
  border: solid 2px
    ${({
  selected
}) => selected ? getBackgroundColor('primary') : getBackgroundColor('darker')};
  border-radius: 2px;
  width: 50px;
  justify-content: center;
  margin: 0 2px;
`;
export const List = styled(TabList)`
  display: flex;
  margin: 0 10px;
`;
export const InstallmentTable = styled.table`
  width: 100%;
  border-spacing: unset;

  & tr:nth-child(n + 13) {
    display: ${({
  allVisible
}) => allVisible ? 'table-row' : 'none'};
  }
`;
export const TableHeading = styled.thead`
  font-family: ${props => themeGet('Helvetica')(props)};
  color: ${props => themeGet('colors.darkSilver')(props)};
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
`;
export const ProductFreight = styled.span`
  font-weight: ${props => themeGet('fontWeights.light')(props)};
  font-style: italic;
`;
export const FeeHeading = styled.th`
  text-align: left;
  padding: 0 10px;
`;
export const FeeBody = styled.td`
  padding: 8px 10px;
  text-align: left;
  color: ${props => getTextColor('base')(props)};
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
`;
export const InstallmentAmount = styled.span`
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
`;
export const TotalHeading = styled.th`
  text-align: right;
  padding: 0 10px;
`;
export const TotalBody = styled.td`
  font-family: ${props => themeGet('Helvetica')(props)};
  color: ${props => getTextColor('base')(props)};
  padding: 0px 10px;
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  text-align: right;
`;
export const PlanTr = styled.tr`
  background-color: ${props => props.index % 2 === 0 ? getBackgroundColor('darker')(props) : null};
`;
export const NumberInstallment = styled.p`
  margin-top: 4px;
  margin-bottom: 8px;
`;
export const Title = styled.span`
  display: flex;
  align-items: center;
  color: ${props => getPaletteColor('primary.base')(props)};
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  margin: 10px;
  font-weight: ${props => themeGet('fontWeight.normal')(props)};
`;
export const Amount = styled.span`
  color: ${props => getTextColor('base')(props)};
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
`;
export const Discount = styled(Text)`
  color: #429502;
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  margin-left: 4px;
`;
export const Description = styled(Text)``;
export const InstallmentMethodText = styled(Text)`
  color: ${props => props.luizaCard ? '#429502' : getPaletteColor('darkSilver')(props)};
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
`;
export const SlipContent = styled.div`
  margin: 10px;
`;
export const ShowMoreButton = styled(Button)`
  width: 100%;
`;
export const LegalText = styled(Text)`
  padding: 8px 4px 8px 10px;
  font-size: 12px;
  font-family: ${props => themeGet('Helvetica')(props)};
  color: #8c8c8c;
  font-style: italic;
`;